(function () {
  function initialize(root) {
    if (root.dataset.reviewReady === 'true') return;
    root.dataset.reviewReady = 'true';
    var grid = root.querySelector('[data-review-grid]');
    var cards = Array.from(grid.querySelectorAll('[data-bc-review-card]')).map(function (element) {
      return { element: element, source: element.dataset.source, topics: (element.dataset.topics || '').split(','), search: element.textContent.toLocaleLowerCase(), length: element.querySelector('blockquote').textContent.trim().length };
    });
    root.querySelectorAll('.bc-review-card__full').forEach(function (details) { details.open = false; });
    var sourceButtons = Array.from(root.querySelectorAll('[data-review-source]'));
    var topicButtons = Array.from(root.querySelectorAll('button[data-review-topic]'));
    var search = root.querySelector('[data-review-search]');
    var count = root.querySelector('[data-review-count]');
    var note = root.querySelector('[data-review-selection-note]');
    var more = root.querySelector('[data-review-more]');
    var sentinel = more.parentElement;
    var initial = Number(root.dataset.initialCount) || 12;
    var allowedSources = ['public', 'all', 'google', 'yelp', 'email'];
    var allowedTopics = ['all'].concat(topicButtons.map(function (button) { return button.dataset.reviewTopic; }));
    var defaultSource = root.dataset.defaultSource || 'public';
    var state = { source: defaultSource, topic: 'all', q: '', limit: initial };
    var observer;
    var matchingCards = [];
    var columns = 1;
    function columnCount() {
      return Math.max(1, window.getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length);
    }
    // The strongest review leads each curated batch with similar-length companions.
    // The remaining excerpts form length-matched rows, ordered by their best rank.
    // Later batches never displace the strongest stories; DOM and visual order agree.
    function arrangeRows(matches) {
      if (columns === 1) return matches.slice();
      var arranged = [];
      for (var offset = 0; offset < matches.length; offset += initial) {
        var batch = matches.slice(offset, offset + initial);
        var anchor = batch.shift();
        var companions = batch.slice().sort(function (a, b) {
          return Math.abs(a.length - anchor.length) - Math.abs(b.length - anchor.length) || cards.indexOf(a) - cards.indexOf(b);
        }).slice(0, columns - 1);
        [anchor].concat(companions).sort(function (a, b) { return cards.indexOf(a) - cards.indexOf(b); }).forEach(function (card) { arranged.push(card); });
        batch = batch.filter(function (card) { return companions.indexOf(card) < 0; });
        batch.sort(function (a, b) { return a.length - b.length || cards.indexOf(a) - cards.indexOf(b); });
        var rows = [];
        for (var rowOffset = 0; rowOffset < batch.length; rowOffset += columns) {
          rows.push(batch.slice(rowOffset, rowOffset + columns).sort(function (a, b) { return cards.indexOf(a) - cards.indexOf(b); }));
        }
        rows.sort(function (a, b) { return cards.indexOf(a[0]) - cards.indexOf(b[0]); });
        rows.forEach(function (row) { row.forEach(function (card) { arranged.push(card); }); });
      }
      return arranged;
    }
    function readURL() {
      var params = new URL(window.location.href).searchParams;
      var source = params.get('source');
      var topic = params.get('topic');
      state.source = allowedSources.indexOf(source) >= 0 ? source : defaultSource;
      state.topic = allowedTopics.indexOf(topic) >= 0 ? topic : 'all';
      state.q = (params.get('q') || '').slice(0, 200);
      state.limit = Math.max(initial, Math.min(cards.length || initial, Number(params.get('show')) || initial));
      search.value = state.q;
    }
    function writeURL(mode) {
      var url = new URL(window.location.href);
      var values = { source: state.source === defaultSource ? '' : state.source, topic: state.topic === 'all' ? '' : state.topic, q: state.q, show: state.limit > initial ? String(state.limit) : '' };
      Object.keys(values).forEach(function (key) { if (values[key]) url.searchParams.set(key, values[key]); else url.searchParams.delete(key); });
      if (url.href !== window.location.href) window.history[mode === 'replace' ? 'replaceState' : 'pushState']({}, '', url.href);
    }
    function sourceMatches(card) { return state.source === 'all' ? true : state.source === 'public' ? card.source === 'google' || card.source === 'yelp' : card.source === state.source; }
    function render() {
      var query = state.q.trim().toLocaleLowerCase();
      columns = columnCount();
      matchingCards = arrangeRows(cards.filter(function (card) { return sourceMatches(card) && (state.topic === 'all' || card.topics.indexOf(state.topic) >= 0) && (!query || card.search.indexOf(query) >= 0); }));
      cards.forEach(function (card) { card.element.hidden = true; });
      var fragment = document.createDocumentFragment();
      matchingCards.forEach(function (card, index) {
        card.element.hidden = index >= state.limit;
        fragment.appendChild(card.element);
      });
      grid.appendChild(fragment);
      sourceButtons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.reviewSource === state.source)); });
      topicButtons.forEach(function (button) {
        var topic = button.dataset.reviewTopic;
        button.hidden = topic !== 'all' && !cards.some(function (card) { return card.topics.indexOf(topic) >= 0; });
        button.setAttribute('aria-pressed', String(topic === state.topic));
      });
      count.textContent = root.dataset.countTemplate.replace('[shown]', String(Math.min(state.limit, matchingCards.length))).replace('[count]', String(matchingCards.length));
      note.textContent = state.source === 'email' ? root.dataset.emailNote : state.source === 'all' ? root.dataset.allNote : root.dataset.publicNote;
      more.hidden = !!observer || matchingCards.length <= state.limit;
      root.querySelector('[data-review-empty]').hidden = matchingCards.length !== 0;
      if (observer) {
        observer.unobserve(sentinel);
        if (matchingCards.length > state.limit) observer.observe(sentinel);
      }
      return matchingCards;
    }
    function revealMore(automatic) {
      var previousLimit = state.limit;
      state.limit = Math.min(matchingCards.length, state.limit + initial);
      var matches = render();
      writeURL(automatic ? 'replace' : 'push');
      if (!automatic && matches[previousLimit]) {
        matches[previousLimit].element.setAttribute('tabindex', '-1');
        matches[previousLimit].element.focus({ preventScroll: true });
      }
    }
    // Native details remain a working fallback. A modal lets readers open the
    // unabridged original without changing the height of any review card.
    var dialog;
    var dialogBody;
    if (typeof HTMLDialogElement !== 'undefined' && HTMLDialogElement.prototype.showModal) {
      dialog = document.createElement('dialog');
      dialog.className = 'bc-reviews__dialog';
      dialog.setAttribute('aria-label', 'Full original review');
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'bc-reviews__dialog-close';
      close.setAttribute('aria-label', 'Close review');
      close.autofocus = true;
      close.textContent = '×';
      dialogBody = document.createElement('div');
      dialog.appendChild(close);
      dialog.appendChild(dialogBody);
      root.appendChild(dialog);
      close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        var bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
    }
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; }) && matchingCards.length > state.limit) revealMore(true);
      }, { rootMargin: '0px 0px 400px 0px' });
      root.classList.add('bc-reviews--auto-load');
    }
    root.querySelector('[data-bc-review-controls]').hidden = false;
    root.addEventListener('click', function (event) {
      var summary = event.target.closest('.bc-review-card__full > summary');
      if (summary && dialog && root.contains(summary)) {
        event.preventDefault();
        summary.parentElement.open = false;
        var card = summary.closest('.bc-review-card');
        dialogBody.replaceChildren(card.querySelector('.bc-review-card__top').cloneNode(true), card.querySelector('.bc-review-card__original').cloneNode(true), card.querySelector('.bc-review-card__byline').cloneNode(true));
        dialog.setAttribute('aria-label', 'Full review by ' + card.querySelector('strong').textContent.trim());
        dialog.showModal();
        return;
      }
      var button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-review-source')) { state.source = button.dataset.reviewSource; state.limit = initial; }
      else if (button.hasAttribute('data-review-topic')) { state.topic = button.dataset.reviewTopic; state.limit = initial; }
      else if (button.hasAttribute('data-review-reset')) { state = { source: defaultSource, topic: 'all', q: '', limit: initial }; search.value = ''; }
      else if (button.hasAttribute('data-review-more')) { revealMore(false); return; }
      else return;
      root.querySelectorAll('.bc-review-card__full').forEach(function (details) { details.open = false; });
      render();
      writeURL();
    });
    var searchTimer;
    search.addEventListener('input', function () {
      state.q = search.value.slice(0, 200);
      state.limit = initial;
      render();
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function () { writeURL('replace'); }, 300);
    });
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { if (columnCount() !== columns) render(); }, 150);
    });
    window.addEventListener('popstate', function () { window.clearTimeout(searchTimer); readURL(); render(); });
    readURL();
    render();
  }
  function mount(scope) {
    (scope || document).querySelectorAll('[data-bc-review-wall]').forEach(initialize);
  }
  window.BuonCiboReviews = { mount: mount };
  mount(document);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
})();
